export default "__VITE_ASSET__SfmS1m$o__"